import Vue from 'vue';

import Router from 'vue-router';
import Cookies from 'js-cookie';

// import api from '$api'
import store from '../store';

import ErrorRouter from './error.router';
import ManageRouter from './manage.router';
import PersonalRouter from './personal.router';
import PreviewRouter from './preview.router';
import UrmRouter from './urm.router';
import OtherRouter from './other.router';

Vue.use(Router);

const router = new Router({
  mode: 'hash', // 'hash' or 'history'
  routes: [{ path: '/', redirect: '/personal/center' }]
});

router.addRoutes(ErrorRouter);
router.addRoutes(ManageRouter);
router.addRoutes(PersonalRouter);
router.addRoutes(PreviewRouter);
router.addRoutes(UrmRouter);
router.addRoutes(OtherRouter);

router.beforeEach((to, from, next) => {
  // 老企业中心跳转到新企业中心
  if (to.path.startsWith('/manage/')) {
    location.href = '/uc/';
    return;
  }
  const token = Cookies.get('token');
  // token不存在默认跳转登录
  if (!token || token === '' || token === null) {
    window.location =
      (location.origin
        ? location.origin
        : location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')) +
      '/account/login?ref=' +
      encodeURIComponent(window.location.href);
  } else {
    // 个人用户
    if (store.getters.user.type === 1) {
      if (to.name.indexOf('Personal') === 0) {
        next();
      } else {
        next({ name: '404' });
      }
    }
    // 企业用户
    if (store.getters.user.type === 2) {
      console.log(to.name);
      if (to.name.indexOf('Enterprise') === 0 || to.name.indexOf('Urm') === 0 || to.name.indexOf('vipList') === 0) {
        next();
      } else {
        next({ name: '404' });
      }
    }
  }
  next();
});

router.afterEach(transition => {
  // console.log(router)
  // let name = transition.name
  // let item = router.options.routes.filter((ele) => { return ele.name === name })
  // console.log(item)
  // document.title = title
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js